module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/record.a263a6e44137f259.gif";